import React, { useState, useContext, useEffect } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import { LiaEyeSlashSolid, LiaEyeSolid } from "react-icons/lia";
import { FiAlertTriangle } from "react-icons/fi";
import { toast } from "react-toastify";
import Spinner from "../../../Spinner/Spinner";
import AccountLayout from "./AccountLayout";
import DeleteAccountSection from "./DeleteAccountSection";
import { AuthContext } from "../../../Context/AuthContext";
import "./UserProfile.css";

const defaultformField = { oldPassword: "", newPassword: "" };

const Accountmanagement = () => {
  const [formfield, setFormField] = useState(defaultformField);
  const { oldPassword, newPassword } = formfield;
  const [showPass1, setShowPass1] = useState(false);
  const [showPass2, setShowPass2] = useState(false);
  const [loading, setLoading] = useState(false);
  const { token, user, Logout } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormField({ ...formfield, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      await axios.post(
        `${process.env.REACT_APP_SERVER_URL}/users/change-password/${user.userId}`,
        { oldPassword, newPassword },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      toast.success("Password changed successfully");
      setFormField(defaultformField);
    } catch (error) {
      toast.error(error.response?.data?.message || "Password change failed");
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = () => {
    Logout();
    navigate("/market");
  };

  useEffect(() => {
    if (window.location.hash === "#delete-account") {
      document.getElementById("delete-account")?.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }, []);

  return (
    <AccountLayout title="Settings">
      <div className="account-settings-page">
        <section className="account-settings-section" id="security">
          <div className="account-settings-section__header">
            <h2>Password &amp; security</h2>
            <p>Update your password to keep your STEX account secure.</p>
          </div>
          <form className="account-settings-form" onSubmit={handleSubmit}>
            <span>
              <label htmlFor="old-password">Current password</label>
              <div className="pass-field">
                <input
                  id="old-password"
                  type={showPass1 ? "text" : "password"}
                  name="oldPassword"
                  value={oldPassword}
                  onChange={handleChange}
                  required
                  autoComplete="current-password"
                />
                <button
                  type="button"
                  className="pass-toggle"
                  onClick={() => setShowPass1(!showPass1)}
                  aria-label={showPass1 ? "Hide password" : "Show password"}
                >
                  {showPass1 ? <LiaEyeSlashSolid /> : <LiaEyeSolid />}
                </button>
              </div>
            </span>
            <span>
              <label htmlFor="new-password">New password</label>
              <div className="pass-field">
                <input
                  id="new-password"
                  type={showPass2 ? "text" : "password"}
                  name="newPassword"
                  value={newPassword}
                  onChange={handleChange}
                  required
                  minLength={6}
                  autoComplete="new-password"
                />
                <button
                  type="button"
                  className="pass-toggle"
                  onClick={() => setShowPass2(!showPass2)}
                  aria-label={showPass2 ? "Hide password" : "Show password"}
                >
                  {showPass2 ? <LiaEyeSlashSolid /> : <LiaEyeSolid />}
                </button>
              </div>
            </span>
            <button type="submit" className="account-btn account-btn--primary" disabled={loading}>
              {loading ? <Spinner /> : "Update password"}
            </button>
          </form>
        </section>

        <section className="account-settings-section">
          <div className="account-settings-section__header">
            <h2>Session</h2>
            <p>Sign out of your account on this device.</p>
          </div>
          <button type="button" className="account-btn account-btn--ghost" onClick={handleLogout}>
            Log out
          </button>
        </section>

        <section className="account-settings-section account-settings-section--danger" id="delete-account">
          <div className="account-settings-section__header account-settings-section__header--danger">
            <span className="account-settings-danger-icon" aria-hidden="true">
              <FiAlertTriangle />
            </span>
            <div>
              <h2>Delete account</h2>
              <p>
                Permanently remove your STEX account. This cannot be undone.
              </p>
            </div>
          </div>
          <DeleteAccountSection />
        </section>

        <p className="account-settings-help">
          Need help? <Link to="/Contact">Contact support</Link> or visit our{" "}
          <Link to="/market/return-policy">return &amp; refund policy</Link>.
        </p>
      </div>
    </AccountLayout>
  );
};

export default Accountmanagement;
